<app-nav></app-nav>
<div class="container mt-4">
    <h2>Введіть промо код</h2>
    <input [(ngModel)]="promo" class="form-control mb-3">
    <div class="text-success mb-2" *ngIf="successText">
        {{successText}}
    </div>
    <div class="text-danger mb-2" *ngIf="errorText">
        {{errorText}}
    </div>
   <div class="d-flex justify-content-end">
       <div>
           <button (click)="applyPromo()" [disabled]="!promo" class="action-btn action-btn hover_action">
               Застосувати промо код <app-i-arrow></app-i-arrow>
           </button>
       </div>
   </div>
</div>
<app-footer></app-footer>
<lib-preloader [loading]="loading"></lib-preloader>
